<template>
  <section role="region" class="how-we-do-section" ref="howWeDoSection">
    <div class="content">
      <div class="head">
        <TheSecondHead chipText="Soluções completas" chipColor="blue-light" titleText="Como fazemos diferente" />
      </div>
      <div class="card">
        <TheCard v-for="solution in solutions" :style="`transition-duration: ${solution.id * 0.5}s !important`"
          v-show="showCards" :class="makeFade ? 'show' : ''" :key="solution.id" :thirdHeading="solution.title"
          :paragraphText="solution.text" :mediaSrc="solution.mediaSrc" :imageAlt="`Icone ${solution.mediaSrc}`" />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">


const solutions = ref<Array<ContentCardItem>>([
  {
    id: 1,
    title: 'Personalizado',
    text: 'Parametrize todas as réguas de comunicação. Definindo periodicidade, canais e mensagens.',
    mediaSrc: 'business/pencil-icon.png'
  },
  {
    id: 2,
    title: 'Omnichannel',
    text: 'Estamos nos principais canais digitais (SMS, e-mail, WhatsApp, Push, RCS, Voz, Social, etc.), para que sua empresa esteja sempre no melhor canal para o seu cliente.',
    mediaSrc: 'business/plane-icon.png'
  },
  {
    id: 3,
    title: 'Governança da comunicação',
    text: 'Consulte e tenha evidência do que foi comunicado, quando, por qual meio e todas as interação do cliente.',
    mediaSrc: 'business/comment-icon.png'
  },
  {
    id: 4,
    title: 'Data Intelligence',
    text: 'Dados sempre à mão para que sua empresa entenda o comportamento dos clientes e possa otimizar a comunicação, ganhando eficiência.',
    mediaSrc: 'business/analytics-icon.png'
  },
])

const showCards = ref<Boolean>(false);
const makeFade = ref<Boolean>(false);
const howWeDoSection = ref<any>(null);

const howWeDoWatcher = () => {
  var section = howWeDoSection.value;

  if ((window.scrollY + section.offsetHeight) >= section.offsetTop) {
    setTimeout(() => {
      makeFade.value = true;
    }, 100);
    window.removeEventListener('scroll', howWeDoWatcher);
  }
}

onMounted(() => {
  showCards.value = true;
  window.addEventListener('scroll', howWeDoWatcher, {passive: true});
  howWeDoWatcher();
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', howWeDoWatcher);
})
</script>

<style lang="scss">
.how-we-do-section {
  max-width: none !important;
  background-image: url(@/assets/images/home/how-it-works/bg-square-mobile.png);
  background-repeat: repeat;
  background-position: center top;
  border-top: 2px solid blue;
  border-bottom: 2px solid blue;

  .content {
    padding: 40px 20.5px 44px;

    .head {
      text-align: center;

      .title {
        margin: 16px 0px 69px;
        font-size: 40px;
      }
    }

    .card {
      display: flex;
      flex-direction: column;
      row-gap: 57px;

      .default-card {
        padding: 58px 40px 40px;
        border: 2px solid blue;
        min-height: 228px;
        overflow: visible;
        box-shadow: none;
        max-width: 320px;

        h3 {
          margin-bottom: 20px;
        }

        .image-box {
          position: absolute;
          top: 0;
          margin-top: -36px;
        }
      }
    }

    @media screen and (min-width: 834px) and (max-width: 959px) {
      padding: 69px 132px 68px;

      .head {
        .title {
          margin: 16px 0px 69px;
          font-size: 40px;
        }
      }

      .card {
        display: grid;
        grid-template-columns: auto auto;
        justify-content: center;
        align-items: stretch;
        column-gap: 63px;

        .default-card {
          height: 274px;

          &:nth-child(1) {
            padding: 58px 30px 86px 31px;
          }

          &:nth-child(2) {
            padding: 58px 16px 42px 17px;
          }

          &:nth-child(3) {
            padding: 58px 23px 66px 24px;
          }

          &:nth-child(4) {
            padding: 58px 33px 42px 34px;
          }
        }
      }
    }

    @media screen and (min-width: 960px) and (max-width: 1199px) {
      max-width: 960px;

      .card {
        column-gap: 32px;

        .default-card {
          padding: 58px 5px 0px;
          min-width: 202px;
          height: 296px;
          width: 100%;
        }
      }
    }

    @media screen and (min-width: 960px) {
      margin: 0 auto;
      max-width: 1211px;

      .card {
        flex-direction: row;
      }
    }

    @media screen and (min-width: 1200px) {
      .card {
        column-gap: 30px;
        justify-content: center;

        .default-card {
          margin: 0px;
          width: 270px;
          height: 274px;

          &:nth-child(1) {
            padding: 58px 30px 86px 31px;
          }

          &:nth-child(2) {
            padding: 58px 14px 42px 15px;
          }

          &:nth-child(3) {
            padding: 58px 23px 66px 24px;
          }

          &:nth-child(4) {
            padding: 58px 33px 42px 34px;
          }
        }
      }
    }

    // Animação de aparecer
    .default-card {
      opacity: 0;
      -webkit-transform: translateY(148px);
      transform: translateY(148px);
    }

    .show {
      -webkit-transition: all 0.75s ease-out 0.75s;
      -moz-transition: all 0.75s ease-out 0.75s;
      -o-transition: all 0.75s ease-out 0.75s;
      transition: all 0.6s ease;
      -webkit-transform: translateY(0px);
      transform: translateY(0px);
      opacity: 1;
    }

    // Fim animação de aparecer
  }
}
</style>